import React, {
  useState
} from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import imgChevronDown from '../../../assets/chevron-down.svg';
import imgChevronUp from '../../../assets/chevron-up.svg';
import { LIGHT_PINK_ORANGE, PALE, SOFT_TOMATO } from '../../colors';

const Container = styled.div`
  overflow: hidden;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0rem 1rem;
  background: ${LIGHT_PINK_ORANGE};
  cursor: pointer;
  align-items: center;

  div {
    display: flex;
    align-items: center;

    img {
      height: 12px;
      width: 12px;
      padding: 0rem 0.5rem;
    }

    p {
      font-family: 'Poppins-SemiBold';
      font-size: 0.9rem;
    }
  }
`;

const Content = styled(motion.div)`
  padding: 1rem;
  
  div {
    
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;

  }
`;

interface TogglePanelProps {
  title: string;
  contents: React.ReactNode;
}

const TogglePanel = ({ title, contents }: TogglePanelProps) => {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Container>
         <Header 
          onClick={() => {
            setIsOpen(!isOpen)
          }}
        >
          <div>
            <p>{title.toUpperCase()}</p>
            <img src={isOpen ? imgChevronUp : imgChevronDown} />
          </div>
        </Header>
        <AnimatePresence>
          {isOpen && (
            <Content
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <div>
                {contents}
              </div>
            </Content>
          )}
        </AnimatePresence>
      </Container>
    </>
  )
}

export default TogglePanel;